"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "colloredo-di-monte-albano": {
    "0d14c96a": [{
      "hkey": "c3c21703",
      "slug": "colloredo-di-monte-albano",
      "name": "Colloredo di Monte Albano",
      "primary": true,
      "skipSearch": false
    }],
    "codugnella": [{
      "hkey": "c3c21703",
      "slug": "colloredo-di-monte-albano",
      "name": "Colloredo di Monte Albano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c49ceb3f": [{
      "hkey": "06b12018",
      "slug": "colloredo-di-monte-albano-lauzzana",
      "name": "Colloredo di Monte Albano-Lauzzana",
      "primary": true,
      "skipSearch": false
    }],
    "lauzzana": [{
      "hkey": "06b12018",
      "slug": "colloredo-di-monte-albano-lauzzana",
      "name": "Colloredo di Monte Albano-Lauzzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "44a64bd9": [{
      "hkey": "c3c21703",
      "slug": "colloredo-di-monte-albano",
      "name": "Colloredo di Monte Albano",
      "primary": true,
      "skipSearch": false
    }],
    "ols": [{
      "hkey": "c3c21703",
      "slug": "colloredo-di-monte-albano",
      "name": "Colloredo di Monte Albano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "216266eb": [{
      "hkey": "c3c21703",
      "slug": "colloredo-di-monte-albano",
      "name": "Colloredo di Monte Albano",
      "primary": true,
      "skipSearch": false
    }],
    "pissignano": [{
      "hkey": "c3c21703",
      "slug": "colloredo-di-monte-albano",
      "name": "Colloredo di Monte Albano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;